<template>
  <!-- One section's band (WEB_V2_BUILD.md §4): the theme decides its rhythm
       (alternating, rules, colour blocks) from data-variant; the section's
       own background choice wins. Width: narrow (reading), normal or wide. -->
  <section class="t-band s2-band" :data-variant="variant" :data-background="background || null" :aria-label="heading || label || null">
    <div class="t-band__inner" :class="widthClass">
      <header v-if="heading || $slots.intro" class="s2-band__head">
        <component :is="headingTag" v-if="heading" class="t-h2 mo-reveal">{{ heading }}</component>
        <slot name="intro" />
      </header>
      <slot />
    </div>
  </section>
</template>

<script setup>
import {useSectionHeadingTag} from "@/composables/useSectionHeadingTag.js";
import {computed} from "vue";
const headingTag = useSectionHeadingTag();

const props = defineProps({
  heading: {type: String, default: ""},
  label: {type: String, default: ""},
  variant: {type: [Number, String], default: 1},
  background: {type: String, default: ""},
  width: {type: String, default: "normal"},
});
const widthClass = computed(() => ({narrow: "s2-narrow", wide: "s2-wide"}[props.width] || ""));
</script>

<style scoped>
.s2-band__head { margin-bottom: clamp(1.25rem, 3vw, 2rem); }
.s2-narrow { max-width: min(var(--t-max-width), 46rem); }
.s2-wide { max-width: min(1400px, 100%); }
</style>
